<i18n src="@/locales/components/RequestNotificationStepsConfigTranslate.json"></i18n>

<template>
	<div class="step-notification-config">
		<div class="step-notification-config__editable" v-if="!isReadonly">
			<div class="mb-5">
				<cbs-relations-humanroles
					multiple
					class="select-multiple w-full"
					v-model="value.relations"
					v-validate="isRequiredTarget ? 'required' : ''"
					:type="0"
					:name="`${formName}-target`"
					:isRequired="isRequiredTarget"
					:title="selectTargetTitle"
					:data-vv-as="selectTargetTitle"
					:placeholder="$t('Placeholder.Target')"
					:getOptionKey="option => option._customId"
				/>
				<span class="text-danger text-sm">{{ errors.first(`${formName}-target`) }}</span>
			</div>

			<div>
				<legend>{{ $t("NotificationContent") }}<span class="text-danger" v-if="isRequiredContent">&nbsp;*</span>:</legend>
				<cbs-editor
					v-model="value.content"
					v-validate="isRequiredContent ? 'required' : ''"
					:name="`${formName}-content`"
					:data-vv-as="$t('NotificationContent')"
					:mentionType="$constant.TEMPLATE_VARIABLES.REQUEST_NOTIFICATION_CONTENT"
				/>
				<span class="text-danger text-sm">{{ errors.first(`${formName}-content`) }}</span>
			</div>
		</div>

		<div class="step-notification-config__readonly" v-else>
			<div class="flex mb-5">
				<legend class="w-1/3 sm:w-1/5">{{ $t("Target") }}:</legend>
				<div class="w-2/3 sm:w-4/5 text-black">{{ value.relations.map(option => option.name).join(", ") }}</div>
			</div>
			<div class="flex">
				<legend class="w-1/3 sm:w-1/5">{{ $t("NotificationContent") }}:</legend>
				<div class="w-2/3 sm:w-4/5 text-black" v-html="value.content"></div>
			</div>
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";
import CbsEditor from "@/components/cbs-editor/CbsEditor";

export default {
	inject: ['parentValidator'],
	name: "StepNotificationConfig",
	components: { vSelect, CbsEditor },
	props: {
		value: {
			type: Object,
			required: true,
			validator: prop => {
				return (
					prop.hasOwnProperty("relations") &&
					prop.hasOwnProperty("content")
				);
			}
		},
		isReadonly: {
			type: Boolean,
			default: false
		},
		isRequiredTarget: {
			type: Boolean,
			default: false
		},
		isRequiredContent: {
			type: Boolean,
			default: false
		},
		formName: String,
		selectTargetTitle: String
	},
	created() {
		if(this.parentValidator) {
			this.$validator = this.parentValidator;
		}
	}
};
</script>

<style lang="scss" scoped>
.step-notification-config {
	::v-deep .quill-editor .ql-container {
		min-height: 75px;

		.ql-editor {
			min-height: 75px;

			&:hover {
				cursor: text;
			}
		}
	}
}
</style>
